if (window.__lpCrushLoaded) { /* every section asks for this file */ }
else { window.__lpCrushLoaded = true;
/* Bathorium Crush Relief Soaks, Hero PDP.
   Three small jobs: the offer tiers, the gallery, and the accordions. */
(function () {
  'use strict';

  var TIERS = {
    '1': {
      title: 'Crush Relief Bath Soaks',
      intro: 'Eight of our best selling bath rituals, for the nights your body needs relief. <strong>Stiff, aching joints</strong>. <strong>Sleep that will not come</strong>. The way you feel through <strong>perimenopause</strong>.',
      benefits: [
        'Magnesium rich salts ease stiff, aching joints',
        'Calming botanicals to help you sleep deeper',
        'Cooling minerals for hot flashes and night sweats',
        'pH balanced 4.5 to 5.5, no synthetic fragrance'
      ],
      sticky: '<strong>The Discovery Set</strong>, $62.99',
      now: '$62.99', was: '$69.99'
    },
    '2': {
      title: 'The Complete Crush Ritual',
      intro: 'Everything in the Discovery Set, plus Hinoki Magnesium Bath Flakes for the nights your body is done. With a <strong>free $25 gift card</strong>.',
      benefits: [
        'Eight scents to choose from, one sachet a bath',
        'A 750g tub of magnesium flakes, many baths in one',
        'Magnesium for stiff joints and deeper sleep',
        'Use them apart, or a scoop of Hinoki in any Crush soak'
      ],
      sticky: '<strong>The Complete Ritual</strong>, $109.00, free $25 gift card',
      now: '$109.00', was: '$134.99'
    }
  };

  /* ---- Gallery ---------------------------------------------------
     Both tiers' slides live in one track. Hiding the other tier's
     takes them out of the flow, so the remaining slides are still one
     frame each and the transform maths holds. */
  function gallery() {
    var root = document.querySelector('[data-gallery]');
    if (!root) return null;
    var track = root.querySelector('[data-track]');
    var thumbs = root.querySelector('[data-thumbs]');
    var tier = '1';
    var at = 0;

    function live() {
      return [].slice.call(track.children).filter(function (s) {
        return s.dataset.tier === tier;
      });
    }

    function paintThumbs() {
      thumbs.innerHTML = '';
      live().forEach(function (slide, i) {
        var b = document.createElement('button');
        b.className = 'gallery__thumb';
        b.type = 'button';
        b.setAttribute('aria-label', 'View image ' + (i + 1));
        b.setAttribute('aria-current', i === at ? 'true' : 'false');
        var img = slide.querySelector('img').cloneNode();
        img.loading = 'lazy';
        img.removeAttribute('width');
        img.removeAttribute('height');
        b.appendChild(img);
        b.addEventListener('click', function () { show(i); });
        thumbs.appendChild(b);
      });
    }

    function show(i) {
      var slides = live();
      if (!slides.length) return;
      at = Math.max(0, Math.min(slides.length - 1, i));
      track.style.transform = 'translate3d(' + (-at * 100) + '%,0,0)';
      [].slice.call(thumbs.children).forEach(function (t, n) {
        t.setAttribute('aria-current', n === at ? 'true' : 'false');
      });
    }

    function setTier(next) {
      tier = String(next);
      [].slice.call(track.children).forEach(function (s) {
        s.style.display = s.dataset.tier === tier ? '' : 'none';
      });
      at = 0;
      track.style.transition = 'none';
      show(0);
      paintThumbs();
      requestAnimationFrame(function () { track.style.transition = ''; });
    }

    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(at + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });

    setTier('1');
    return setTier;
  }

  /* ---- Offer tiers ------------------------------------------------ */
  function tiers(setGalleryTier) {
    var cards = [].slice.call(document.querySelectorAll('.tier'));
    var buy = document.querySelector('[data-buy]');
    var stickyBuy = document.querySelector('[data-sticky-buy]');
    var stickyText = document.querySelector('[data-sticky-text]');
    var title = document.querySelector('[data-title]');
    var intro = document.querySelector('[data-intro]');
    var benefits = document.querySelector('[data-benefits]');
    if (!cards.length) return;

    function select(card) {
      var i = cards.indexOf(card);
      var key = String(i + 1);
      var copy = TIERS[key];

      cards.forEach(function (c) {
        var on = c === card;
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        c.setAttribute('tabindex', on ? '0' : '-1');
      });

      if (buy && card.dataset.cart) buy.setAttribute('href', card.dataset.cart);
      if (stickyBuy && card.dataset.cart) stickyBuy.setAttribute('href', card.dataset.cart);
      if (copy) {
        var liveNow = card.querySelector('.tier__now');
        var liveWas = card.querySelector('.tier__was');
        var liveName = card.querySelector('.tier__name');
        var bNow = document.querySelector('[data-buy-now]');
        var bWas = document.querySelector('[data-buy-was]');
        if (bNow) bNow.textContent = liveNow ? liveNow.textContent : '';
        if (bWas) bWas.textContent = liveWas ? liveWas.textContent : '';
        if (stickyText) {
          stickyText.innerHTML = '<strong>' + (liveName ? liveName.textContent : '') +
            '</strong>, ' + (liveNow ? liveNow.textContent : '');
        }
      }
      if (setGalleryTier) setGalleryTier(key);
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { select(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(card); }
      });
    });
    select(cards[0]);
  }

  /* ---- Accordions, one open at a time inside each group ----------- */
  function accordions() {
    [].slice.call(document.querySelectorAll('.acc__btn')).forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        var group = btn.closest('.acc');
        if (group && !open) {
          [].slice.call(group.querySelectorAll('.acc__btn[aria-expanded="true"]')).forEach(function (o) {
            o.setAttribute('aria-expanded', 'false');
            var p = document.getElementById(o.getAttribute('aria-controls'));
            if (p) p.hidden = true;
          });
        }
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
      });
    });
  }


  /* ---- Review carousel, one at a time ----------------------------- */
  function reviews() {
    var root = document.querySelector('[data-revcar]');
    if (!root) return;
    var track = root.querySelector('[data-revcar-track]');
    var dots = root.querySelector('[data-revcar-dots]');
    var items = [].slice.call(track.children);
    var at = 0;
    var timer;

    function show(i) {
      at = (i + items.length) % items.length;
      track.style.transform = 'translate3d(' + (-at * 100) + '%,0,0)';
      [].slice.call(dots.children).forEach(function (d, n) {
        d.setAttribute('aria-current', n === at ? 'true' : 'false');
      });
    }

    items.forEach(function (_, i) {
      var b = document.createElement('button');
      b.className = 'revcar__dot';
      b.type = 'button';
      b.setAttribute('aria-label', 'Review ' + (i + 1));
      b.addEventListener('click', function () { show(i); rearm(); });
      dots.appendChild(b);
    });

    function rearm() {
      clearInterval(timer);
      timer = setInterval(function () { show(at + 1); }, 6000);
    }

    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { show(at + (dx < 0 ? 1 : -1)); rearm(); }
      x0 = null;
    }, { passive: true });

    show(0);
    rearm();
  }

  /* ---- Sticky bar, once the offer has scrolled away --------------- */
  function sticky() {
    var bar = document.querySelector('[data-sticky]');
    var offer = document.getElementById('offer');
    if (!bar || !offer) return;
    function check() {
      bar.classList.toggle('is-on', offer.getBoundingClientRect().bottom < 0);
    }
    addEventListener('scroll', check, { passive: true });
    addEventListener('resize', check);
    check();
  }

  function start() {
    var setTier = gallery();
    tiers(setTier);
    accordions();
    reviews();
    sticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

  /* The star line is already on the page, drawn by the theme, so nothing
     flashes or resizes. Stamped's numbers arrive a second or two later; if
     they differ from the ones Shopify gave us, only the digits change. */
  (function () {
    function sync() {
      var boxes = document.querySelectorAll('.lpc .ratingbox');
      var done = 0;
      for (var i = 0; i < boxes.length; i++) {
        var box = boxes[i];
        var slot = box.querySelector('[data-starline-text]');
        var cap = box.querySelector('.stamped-badge-caption');
        if (!slot) { done++; continue; }
        if (!cap) continue;
        var score = cap.getAttribute('data-rating');
        var count = cap.getAttribute('data-reviews');
        if (!score || !count) continue;
        var wanted = score + '/5 ' + count + ' Reviews';
        if (slot.textContent !== wanted) slot.textContent = wanted;
        box.setAttribute('aria-label',
          'Rated ' + score + ' out of 5 from ' + count + ' reviews');
        done++;
      }
      return boxes.length > 0 && done === boxes.length;
    }
    if (sync()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (sync() || tries > 40) clearInterval(timer);
    }, 400);
  })();

}
